import '../styles/index.scss';
import { createApp } from 'vue';
import VueToast from 'vue-toast-notification';
import { setupI18n } from '@/i18n';

import App from './AppPassword.vue';

/* CSP: propagate the request nonce to any chunk webpack loads at runtime.
   webpack reads __webpack_nonce__ when it creates <script> elements for dynamic
   imports (e.g. locale chunks). Static imports above are already in the bundle. */
/* eslint-disable no-underscore-dangle, camelcase, @typescript-eslint/no-unused-vars */
declare let __webpack_nonce__: string | undefined;
{
  const s = document.currentScript as HTMLScriptElement | null;
  const nonce = s ? s.nonce || s.getAttribute('nonce') || '' : '';
  if (nonce) {
    __webpack_nonce__ = nonce;
  }
}
/* eslint-enable no-underscore-dangle, camelcase, @typescript-eslint/no-unused-vars */

const i18n = setupI18n();
const app = createApp(App);
app.use(VueToast);

app.use(i18n);
app.mount('#app');
